import { Heading, Image, Text, VStack } from "@chakra-ui/react";
import React from "react";

const Card = ({ service, index, props ,pos,topheight,leftside,rightside,bottomheight,cardwidth,cardicon }) => {
  return (
    <>
      <VStack
                  className="fade-in-up"
                  backgroundRepeat={"no-repeat"}
      position={pos}
      left={leftside}
      right={rightside}
      top={topheight}
      bottom={bottomheight}
        key={index}
        bgImage={`url(${service.image})`}
        objectFit={'cover'}
        bgSize="contain"
        bgPosition="center"
        p={6}
        borderRadius="md"
        color="white"
        textAlign="center"
        height={{ base: "45vh", md: "70vh" }}
        maxW={{ base: "100%", md: "100%" }}
        width={{ base: "100%", md: cardwidth || "80%" }}
        justifyContent="center"
        // marginRight={{ base: "0", md: index === 0 ? "200px" : "0px" }}
        // marginLeft={{ base: "0", md: index === 1 ? "200px" : "0px" }}
        // my={{ base: 8, md: 8 }}
        {...props}
      >
        <Image src={service.cardicon || ''} width={'60px'}/>
        <Heading fontSize="lg">{service.title}</Heading>
        <Text fontSize="sm">{service.description}</Text>
      </VStack>
    </>
  );
};

export default Card;
